const ITEMS = [
  "Home Remodels",
  "Custom Decks",
  "Room Additions",
  "Fencing",
  "Roofing",
  "Tree Services",
  "Handyman Services",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display uppercase text-2xl sm:text-4xl text-bone tracking-wide px-6 sm:px-10">{item}</span>
        <span className="w-2.5 h-2.5 bg-safety rotate-45 shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="services-marquee" className="relative border-y border-line bg-ink-card/60 py-5 sm:py-7 overflow-hidden">
      <div className="marquee-track flex w-max">
        <Row />
        <Row ariaHidden={true} />
      </div>
    </div>
  );
}
